import { SUBJECT_TYPE_FILTER_ALL } from '../../services/reportFilterHelper'

const SubjectTypeFilterSelect = ({ value = SUBJECT_TYPE_FILTER_ALL, onChange, name = 'subjectType' }) => (
  <select name={name} value={value} onChange={onChange}>
    <option value={SUBJECT_TYPE_FILTER_ALL}>مجموع</option>
    <option value={0}>بازی‌ها</option>
    <option value={1}>ویدئوها</option>
  </select>
)

export default SubjectTypeFilterSelect
